<template>
<section style="min-height: 500px">
    <b-overlay :show="showOverlay" rounded="lg" no-center="true">
        <template #overlay>
            <div class="text-center" style="margin-top: 300px;">
                <b-spinner v-if='csvUploadMessage === $t("csv_upload_loading")' style="width: 3rem; height: 3rem;margin-bottom:1rem" label="Large Spinner"></b-spinner>
                <p id="cancel-label">{{ csvUploadMessage }}</p>
                <b-button v-if='csvUploadMessage !== $t("csv_upload_loading")' class="btn green-rflocus" size="sm" @click="showOverlay = false">
                    OK
                </b-button>
            </div>
        </template>
        <b-nav v-if="!customerMasterMode" justified tabs>
            <b-nav-item :active="categorie.isActive" :disabled="isBusy || mutationBusy" @click="setCategorieActive(categorie)" v-bind:key="categorie.id" v-for="categorie of categories">{{ categorie.name }}
            </b-nav-item>
        </b-nav>

        <page-header v-if="getCurrentActiveCategorie() && formItems.length !== 0" :title="displayTitle" style="-webkit-user-select: none; /* Safari */">
            <app-form :key="getCurrentActiveCategorie().label" ref="ledgerForm" :items="formItems" :working="isBusy" :csvWorking="isCsvBusy" :noCsvDownload="getCurrentActiveCategorie().customerFlag" @fetchSearch="submitFormSearch" :form_select_options="form_select_options" @fetchCsv="downloadCSV()" />
        </page-header>

        <b-form-select v-if="getCurrentActiveCategorie() !== undefined && getCurrentActiveCategorie().label === 'location'" v-model="warehouseSelect" :options="listWarehouses" :disabled="mutationBusy" class="mb-3" />
        
        <div class="row" style="margin-top:10px">
                <b-input-group v-if="getCurrentActiveCategorie() !== undefined && (getCurrentActiveCategorie().label === 'item' || getCurrentActiveCategorie().customerFlag === true)" class="paginate_count" size="sm" :prepend="$t('total')" style="float:right;width:150px !important">
                    <b-form-input class="align-middle" :modelValue="masterCount" disabled>
                    </b-form-input>
                </b-input-group>
        </div>
        <div class="table-wrapper">
        <b-table :busy="isBusy" borderless striped responsive :fields="sortableHeaders" thead-tr-class="ledger_main_table_th" :items="currentData" tbody-tr-class="pointer" @headClicked="sortChange">
            <template v-slot:head()="data">
                <div class="ledger-sort-header">
                    <span>{{ data.label }}</span>
                    <i-bi-caret-down-fill v-if="getHeadSortDirection(data) === undefined" style="visibility: hidden" />
                    <i-bi-caret-up-fill v-else-if="getHeadSortDirection(data) === 'asc'" />
                    <i-bi-caret-down-fill v-else-if="getHeadSortDirection(data) === 'desc'" />
                </div>
            </template>
            <template v-slot:cell(epc)="data">
                <div v-if="data.value !== undefined && data.value !== null && data.value.length !== 0">
                    <span>{{ data.value.join(',') }}</span>
                </div>
            </template>
            <template v-slot:cell(map)="data">
                <div class="d-flex ">
                    <div v-if="data.item.upload !== undefined && data.item.upload !== null" style="margin-right: 0.25rem !important;">
                        <ButtonEdit @click="$router.push(`/map/${data.item.id}/edit/${this.$route.params.id}?warehouse=${this.$route.query.warehouse}`)">
                            <img v-if="data.item.imageLoadFlag" :src="data.item.signedURL" class="map-button" width="40" height="30" />
                            <i v-else class="fa fa-map"></i>
                        </ButtonEdit>
                    </div>
                    <div v-else style="margin-right: 0.25rem !important;">
                        <ButtonAdd class="create_label" @click="$router.push(`/map/${data.item.id}/create/${this.$route.params.id}?warehouse=${this.$route.query.warehouse}`)">{{ $t("button.create") }}</ButtonAdd>
                    </div>
                    <ButtonAdd>
                        <label class="upload_csv_label" :for="`mapfile${data.index}`">
                            <i class="fa fa-cloud-upload m-r-5"></i>
                            <span>{{ $t("import_csv") }}</span>
                        </label>
                    </ButtonAdd>
                    <input type="file" :id="`mapfile${data.index}`" multiple @change="handleMapFileUpload($event, data.item.id, data.index)" hidden />

                </div>
            </template>
            <template v-slot:cell(robot_orientation)="data">
                <span v-if="data.value !== undefined && data.value !== null">{{ $t(`robot_orientation.${data.value.toString()}`) }}</span>
            </template>
            <template v-slot:cell()="data">
                <template v-if="data.field.inputType === 7 && data.value">
                    <template v-for="(part, index) in splitUrlValues(data.value)" :key="index">
                        <a v-if="isLinkablePart(part)" href="#" @click.prevent="openUrlOrImage(part)">{{ part }}</a><span v-else>{{ part }}</span><template v-if="index < splitUrlValues(data.value).length - 1">, </template>
                    </template>
                </template>
                <span v-else>{{ data.value }}</span>
            </template>
        </b-table>
        </div>
        <div class="row">
            <div class="col-12">
                <b-button v-if="!customerMasterMode && !(getCurrentActiveCategorie() !== undefined && getCurrentActiveCategorie().label === 'location')" class="btn green-rflocus mr-1" @click="openModalCreateRow()">
                    <i class="fa fa-plus-square"></i> {{ $t("button.create") }}
                </b-button>
                <b-button class="btn green-rflocus mr-1" @click="openModalUpdateRow()">
                    <i class="fa fa-plus-square"></i> {{ $t("button.update") }}
                </b-button>
                <b-button v-if="!customerMasterMode && !(getCurrentActiveCategorie() !== undefined && (getCurrentActiveCategorie().label === 'location' || getCurrentActiveCategorie().label === 'warehouse')) " size="sm" class="btn green-rflocus mr-1"  @keydown.enter="triggerFileInput">
                    <label class="upload_csv_label" for="file">
                        <i class="fa fa-cloud-upload m-r-5"></i>
                        <span>{{ $t("button.csv_upload") }}</span>
                    </label>
                </b-button>
                <input type="file" id="file" ref="file" accept=".csv, .xlsx, .xlsm" v-on:change="handleFileUpload()" hidden />

                <b-button v-if="!customerMasterMode && categories[0].isActive" class="btn green-rflocus mr-1" @click="onClickDeleteAll()">
                    <i class="fa fa-trash mr-1"></i>{{ $t("button.delete_all") }}
                </b-button>

                 <button v-if="getCurrentActiveCategorie() !== undefined && getCurrentActiveCategorie().customerFlag === true" type="button" class="btn btn-success btn-rounded w-md waves-effect waves-light my-3 mr-1" @click="downloadCSV(getCurrentActiveCategorie().label)" :disabled="isCsvBusy">
                    <template v-if="csvWorking">
                        <i class="fa fa-spin fa-hourglass m-r-5"></i>
                        {{ $t("processing") }}
                    </template>
                    <template v-else>
                        <i class="fa fa-cloud-download m-r-5"></i>
                        <span>{{ $t("csv_output") }}</span>
                    </template>

                </button>
                <b-pagination align="center" size="sm" :disabled="isBusy || mutationBusy" :total-rows="pagination.totalRow" v-model="currentPage" :per-page="pagination.perPage"></b-pagination>
            </div>
        </div>

        <!-- <modal-setting> -->
        <b-modal v-model="ledgerModal" size="xxl" ref="ledgerModal" @hide="onHideLedgerModal">
            <fieldset :disabled="mutationBusy">
            <div class="table-wrapper">
            <!-- !header-->
            <b-table ref="ledgerTable" :fields="modalHeaders" :items="modalItemData" hover :selectable="true" responsive :select-head="false" @rowSelected="rowSelected" @rowUnselected="rowUnselected">

                <template v-slot:head()="data">
                    <template v-if="categories[0].isActive && data.label === $t('select')">
                        <b-form-checkbox v-model="selectAll" @change="onclickSelectAll()"></b-form-checkbox>
                    </template>
                    <template v-else>{{data.label}}</template>
                </template>

                <template v-slot:cell(delete)="data">
                    <b-form-checkbox v-model="selection" :value="data.item"></b-form-checkbox>
                </template>

                <template v-slot:cell()="data">

                    <template v-if="currentSelect !== null && currentSelect.id === data.item.id">
                        <b-form-input size="sm" :modelValue="data.item[data.field.key]" @input="updateItem($event, data.item, data.field.key)" type="search"></b-form-input>
                    </template>

                    <template v-else>
                        <span>{{data.item[data.field.key]}}</span>
                    </template>

                </template>

                <template v-slot:cell(id)="data">
                    <span>{{data.item.id}}</span>
                </template>

                <template v-slot:cell(warehouseId)="data">
                    <span>{{data.item.warehouseId}}</span>
                </template>
                <template v-slot:cell(epc)="data">
                    <div v-if="data.value !== undefined && data.value !== null && data.value.length !== 0">
                        <span>{{ data.value.join(',') }}</span>
                    </div>
                </template>
                <template v-slot:cell(searchFinishedFlag)="data">
                    <b-form-checkbox id="checkbox-1" v-model="data.value" name="checkbox-1" @change="updateItem($event, data.item, data.field.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(robot_orientation)="data">
                    <b-form-select v-model="data.value" :options="robot_orientation_options" class="mb-3" @change="updateItem($event, data.item, data.field.key)" />
                </template>
                <template v-slot:cell(number)="data">

                    <template v-if="currentSelect !== null && currentSelect.id === data.item.id">
                        <b-form-input :modelValue="data.item[data.field.key]" type="number" @input="updateItem($event, data.item, data.field.key)"></b-form-input>
                    </template>

                    <template v-else>
                        <span>{{data.item[data.field.key]}}</span>
                    </template>
                </template>

            </b-table>
            </div>
            </fieldset>
            <template v-slot:footer>
                <div class="w-100 d-flex justify-content-between">
                    <ButtonAdd v-if="modalCreate" :disabled="mutationBusy" @click="onclickAddItem"></ButtonAdd>
                    <div v-else></div>
                    <div>
                        <button v-if="getCurrentActiveCategorie() !== undefined && getCurrentActiveCategorie().label === 'warehouse'" type="button" class="btn btn-outline-success btn-rounded w-md waves-effect waves-light mr-2" @click="downloadWarehouseCsv" :disabled="csvWorking || mutationBusy">
                            <template v-if="csvWorking">
                                <i class="fa fa-spin fa-hourglass m-r-5"></i>
                                {{ $t("processing") }}
                            </template>
                            <template v-else>
                                <i class="fa fa-cloud-download m-r-5"></i>
                                <span>{{ $t("csv_output") }}</span>
                            </template>
                        </button>
                        <div v-else></div>
                        <ButtonSave :disabled="mutationBusy" @click="onclickItemUpdate"></ButtonSave>
                        <ButtonDelete :disabled="mutationBusy" @click="onclickItemDelete"></ButtonDelete>
                    </div>
                </div>
            </template>
        </b-modal>

        <b-modal :title="$t('saveFailedTitle')" v-model="modalAlertSaveFailed" size="s" ok-only>
            <p v-for="messageKey in saveFailedMessageKeys" :key="messageKey">{{ $t(messageKey) }}</p>
        </b-modal>

        <b-modal :title="$t('deleteFailedTitle')" v-model="modalAlertDeleteFailed" size="s" ok-only>
            <p>{{ $t('deleteFailed') }}</p>
        </b-modal>

        <b-modal title="Delete Master" v-model="modalAlertDeleteMaster" size="s" @ok="deleteMasterDataFun">
            <p>{{ $t("confirm_ledger_delete") }}</p>
        </b-modal>

        <b-modal title="Delete Warehouse" v-model="modalAlertDeleteWarehouse" size="s" @ok="deleteDataFun">
            <p>{{ $t("confirm_map_delete") }}</p>
            <p>{{ $t("map_id") }}</p>
            <p>{{ selection.map((item) => item.id).join(", ") }}</p>
        </b-modal>

        <b-modal title="Delete Location" v-model="modalAlertDeleteLocation" size="s" @ok="deleteDataFun">
            <p>{{ $t("confirm_location_delete") }}</p>
            <p>{{ $t("location_id") }}</p>
            <p>{{ selection.map((item) => item.label).join(", ") }}</p>
        </b-modal>
    </b-overlay>
</section>
</template>

<style>
.map-button {
    vertical-align: text-bottom;
}
</style>

<script>
import readRequests from "../../mixins/readRequests.js";
import ButtonAdd from "../../components/buttons/ButtonAdd.vue";
import ButtonDelete from "../../components/buttons/ButtonDelete.vue";
import ButtonSave from "../../components/buttons/ButtonSave.vue";
import * as queries from "../../graphql/locus_queries";
import * as mutations from "../../graphql/locus_mutations";
import global from "../../Global.vue";
import Form from '../../components/form/Form.vue'
import PageHeader from '../layout/PageHeader.vue'
import AwsApi from "../../Api"
import {
    v4 as uuidv4
} from "uuid"

import {
    API,
    graphqlOperation,
    Storage
} from "aws-amplify";
import {
    onUpdateProcessJob
} from "../../graphql/locus_subscriptions";

export default {
    mixins: [readRequests],
    props: {
        customerMasterMode: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ButtonSave,
        ButtonDelete,
        ButtonAdd,
        'app-form': Form,
        PageHeader
    },
    data() {
        return {
            tenantId: "",
            limit: 1000,
            offset: 0,
            allData: [],
            currentData: [],
            pagination: {
                totalRow: 0,
                perPage: 0
            },
            currentPage: 1,
            count: 15,
            isBusy: false,
            isCsvBusy: false,
            modalCreate: false,
            warehouseSelect: null,
            categories: [{
                    label: "item",
                    name: this.$t("ledger.items"),
                    isActive: true,
                    header: [
                        //     {
                        //     key: "itemCode",
                        //     label: this.$t("item_code"),
                        //     id: 0,
                        // }
                    ],
                    url: {
                        delete: mutations.deleteItemMaster
                    }
                },
                {
                    label: "warehouse",
                    name: this.$t("ledger.map"),
                    isActive: false,
                    header: [{
                        key: "id",
                        label: "id",
                        thStyle: {
                            "min-width": '100px'
                        }
                    }, {
                        key: "name",
                        label: this.$t("warehouse_name"),
                        thStyle: {
                            "min-width": '200px'
                        }
                    }, {
                        key: "item_tag_filter",
                        label: "item_tag_filter",
                        thStyle: {
                            "min-width": '300px'
                        }
                    }, {
                        key: "location_tag_filter",
                        label: "location_tag_filter",
                        thStyle: {
                            "min-width": '200px'
                        }
                    }, {
                        key: "map",
                        label: this.$t("ledger.map"),
                        thStyle: {
                            "min-width": '180px'
                        }
                    }, {
                        key: "remarks",
                        label: "remarks",
                        thStyle: {
                            "min-width": '100px'
                        }
                    }, {
                        key: "rssi_threshhold",
                        label: "location_tag_rssi_threshold",
                    },{
                        key: "product_rssi_threshhold",
                        label: "product_tag_rssi_threshold",
                    }, {
                        key: "state_change_interval",
                        label: "state_change_interval",
                    }, {
                        key: "all_shelves_scan_percentage",
                        label: "all_shelves_scan_percentage",

                    }, {
                        key: "robot_home_x",
                        label: "robot_home_x",

                    }, {
                        key: "robot_home_y",
                        label: "robot_home_y",

                    }, {
                        key: "robot_stop_meters",
                        label: "robot_stop_meters",

                    }, {
                        key: "robot_stop_seconds",
                        label: "robot_stop_seconds",

                    }, {
                        key: "robot_distance",
                        label: "robot_distance",

                    }, {
                        key: "robot_orientation",
                        label: "robot_orientation",

                    }, {
                        key: "shelf_transparency",
                        label: "shelf_transparency",

                    }],
                    url: {
                        delete: mutations.deleteWarehouse
                    }
                },
                {
                    label: "location",
                    name: this.$t("ledger.location"),
                    isActive: false,
                    header: [{
                            key: "number",
                            label: this.$t("number"),
                        }, {
                            key: "label",
                            label: this.$t("location")
                        },
                        {
                            key: "warehouseId",
                            label: `${this.$t("warehouse")}`,
                        }, {
                            key: "epc",
                            label: this.$t("epc"),
                        },
                    ],
                    url: {
                        delete: mutations.deleteLocation
                    }
                }
            ],
            headers: [],
            selection: [],
            modalItemData: [],
            tmpId: 0,
            reader: new FileReader(),
            updateCsvPath: "",
            form: null,
            formItems: [],
            itemMasterFormItems: [],
            form_select_options: {},
            displayTitle: this.$t("search"),
            loading: false,
            showOverlay: false,
            csvUploadMessage: this.$t("csv_upload_loading"),
            ledgerModal: false,
            currentSelect: null,
            modalAlertDeleteWarehouse: false,
            modalAlertDeleteFailed: false,
            modalAlertSaveFailed: false,
            saveFailedMessageKeys: [],
            modalAlertDeleteLocation: false,
            listLocations: [],
            listLocationTags: [],
            selectAll: false,
            modalAlertDeleteMaster: false,
            subscription: null,
            uploadCSVTimer: null,
            dataChangeFlag: false,
            csvWorking: false,
            mutationBusy: false,
            listLocations: [],
            listWarehouses: [],
            masterCount: 0,
            customerTableName: "",
            sortBy: [],
            robot_orientation_options:[
                            { value: 0, text: 'UP'},
                            { value: 1, text: 'LEFT' },
                            { value: 2, text: 'DOWN' },
                            { value: 3, text: 'RIGHT' }]
        };

    },
    computed: {
        sortableHeaders() {
            return this.headers.map(header => {
                const direction = this.getSortDirection(header.key)
                const headerClass = Array.isArray(header.thClass) ? header.thClass : (header.thClass ? [header.thClass] : [])
                return {
                    ...header,
                    thClass: ['sorting', 'word-break-keep', ...headerClass, direction].filter(Boolean),
                    sortDirection: direction
                }
            })
        },
        modalHeaders() {
            var currentHeaders = this.headers
            const currentActiveCategorie = this.getCurrentActiveCategorie();
            if (currentActiveCategorie.label === "warehouse") {
                currentHeaders = this.headers.filter(item => item.key !== "map")
            }
            return [{
                key: 'delete',
                label: this.$t("select"),
            }, ...currentHeaders]
        }
    },

    async mounted() {
        if (!this.customerMasterMode) {
            this.addSubscription()
        }
        if (!this.customerMasterMode && this.$route.params.categorie === "1") {
            this.categories[0].isActive = false
            this.categories.filter(item => item.label === "warehouse")[0].isActive = true
        }
        this.tenantId = sessionStorage.getItem(global.tenantId);
        if (this.customerMasterMode) {
            await this.initializeCustomerMasterMenu()
        } else {
            this.fetchTenant()
            this.fetchMenuSettings()
            this.setDataFromCurrentActiveCategorie();
        }

        this.reader.addEventListener("load", function (event) {
            this.showOverlay = true
            this.csvUploadMessage = this.$t("csv_upload_loading")
            this.uploadCSV(this.reader.result).then((response) => {
                if (response === undefined) {
                    this.csvUploadMessage = this.$t("csv_upload_error")
                    return
                }
                const categorie = this.getCurrentActiveCategorie();
                if (categorie.label === "item") {
                    var callApiTime = new Date().getTime()
                    this.uploadCSVTimer = setInterval(() => {
                        if (new Date().getTime() - callApiTime >= global.timeout) {
                            clearInterval(this.uploadCSVTimer)
                            this.csvUploadMessage = this.$t("csv_upload_timeout")
                        }
                    }, 1000)
                } else {
                    setTimeout(() => {
                        this.clearData()
                        this.setDataFromCurrentActiveCategorie()
                        this.csvUploadMessage = this.$t("csv_upload_success")
                    }, 3000)

                }

                this.clearInput()
            })
        }.bind(this), false);
    },

    watch: {
        warehouseSelect: function () {
            this.clearData()
            this.setDataFromCurrentActiveCategorie();
        },
        currentPage: function () {
            this.updatePage();
        }
    },
    unmounted() {
        console.log("unsubscribe");
        if (this.subscription !== null) {
            this.subscription.unsubscribe();
        }
    },
    methods: {
        // A ケースマーク画像-style URL field can hold several
        // comma-separated entries (multiple photos attached to one row) --
        // each one needs to become its own independent link rather than
        // treating the whole joined string as a single URL/S3 key.
        splitUrlValues(value) {
            if (!value) {
                return []
            }
            return String(value).split(',').map(part => part.trim()).filter(part => part.length > 0)
        },
        // inputType=7 (URL): a value that's already a complete URL (has an
        // explicit http(s):// scheme) opens as-is; otherwise it's treated
        // as an S3 key (already including its own "images/..." etc. path)
        // under this tenant's own public prefix (matching the
        // "public/{tenantId}/..." level convention used elsewhere for
        // warehouse map uploads) and resolved through Storage.get().
        // Checking for an explicit scheme (rather than guessing from
        // whether the string "looks like" a domain) matters because a bare
        // filename like "a.jpg" also contains a dot and would otherwise be
        // misread as a hostname.
        isCompleteUrl(value) {
            if (!value) {
                return false
            }
            try {
                const parsed = new URL(String(value).trim())
                return parsed.protocol === 'http:' || parsed.protocol === 'https:'
            } catch (error) {
                return false
            }
        },
        // Guesses a MIME type from the filename extension. The S3 object's
        // own stored Content-Type is often wrong or generic (e.g. uploaded
        // as application/octet-stream) -- a browser can't render that
        // inline no matter what Content-Disposition says, and falls back
        // to downloading it. Forcing a real image content type on the
        // presigned URL itself sidesteps whatever the object was actually
        // uploaded with.
        guessImageContentType(value) {
            const match = /\.([a-z0-9]+)$/i.exec(String(value).trim())
            const ext = match ? match[1].toLowerCase() : ''
            const types = {
                jpg: 'image/jpeg',
                jpeg: 'image/jpeg',
                png: 'image/png',
                gif: 'image/gif',
                webp: 'image/webp',
                bmp: 'image/bmp',
                svg: 'image/svg+xml',
            }
            return types[ext] || null
        },
        // A URL-type field can also hold a plain status label with no file
        // at all (e.g. "伝票無し" meaning "no slip attached") rather than a
        // real filename -- rendering that as a link just leads to a raw S3
        // NoSuchKey error page when clicked. Only values that are either a
        // complete URL or look like a real image filename become links;
        // anything else displays as plain text.
        isLinkablePart(value) {
            return this.isCompleteUrl(value) || !!this.guessImageContentType(value)
        },
        async openUrlOrImage(value) {
            if (this.isCompleteUrl(value)) {
                window.open(String(value).trim(), '_blank')
                return
            }
            // window.open() must happen synchronously within the click
            // handler or popup blockers can silently swallow it once an
            // await has passed -- open a blank tab now and navigate it
            // once the presigned URL below is ready.
            const newTab = window.open('', '_blank')
            try {
                // Without contentDisposition, the presigned URL inherits
                // whatever the object was uploaded with (often "attachment"
                // or none, which browsers treat as "download this" rather
                // than "show this"), regardless of how the link itself is
                // opened. Forcing "inline" (and a real contentType, see
                // guessImageContentType above) overrides that on the URL
                // itself, independent of the object's own stored metadata.
                const contentType = this.guessImageContentType(value)
                const options = { contentDisposition: 'inline' }
                if (contentType) {
                    options.contentType = contentType
                }
                const imageUrl = await Storage.get(`${this.tenantId}/${value}`, options)
                if (newTab) {
                    newTab.location.href = imageUrl
                } else {
                    window.open(imageUrl, '_blank')
                }
            } catch (error) {
                console.error(error)
                if (newTab) {
                    newTab.close()
                }
            }
        },
        async fetchTenant() {
            const response = await AwsApi.graphql({
                query: queries.getTenant,
                variables: {
                    tenantId: this.tenantId
                }
            }, this);
            if (response === undefined) {
                return
            }
            const customerMasters = response.data.getTenant.customer_masters
            if (customerMasters !== undefined && customerMasters !== null && customerMasters.length > 0) {   
                var startIndex = 1    
                for (const value of customerMasters) {
                    var master = JSON.parse(value)
                    const response = await AwsApi.graphql({
                        query: queries.queryHeadersWithTable,
                        variables: {
                            tenantId: this.tenantId,
                            sourceTable: master.key
                        }
                    }, this);
                    if (response === undefined || response.data.queryItemDefines.items.length == 0) {
                        return
                    }
                    const headers = response.data.queryItemDefines.items.map(item => {
                        const datas = item.source.split('.')
                        var itemKey = ""
                        if (datas.length == 2) {
                            itemKey = datas[1]
                        } else if (datas.length == 3) {
                            itemKey = datas[2]
                        }
                        return {
                            key: itemKey, //item.itemKey !== null ? item.itemKey : item.name,
                            label: item.name,
                            id: item.order, //item.id
                            source: item.source
                        }
                    }).sort(function (first, second) {
                        return first['id'] - second['id']
                    });
                    this.categories.splice(startIndex, 0, {
                        label: master.key,
                        name: master.name,
                        isActive: false,
                        customerFlag: true,
                        searchFields: response.data.queryItemDefines.items,
                        header: headers,
                        url: {
                            delete: mutations.deleteCustomerMaster
                        }
                    });
                    startIndex = startIndex + 1
                    
                }
            }
        },
        addSubscription() {
            console.log("subscription");
            this.subscription = API.graphql(graphqlOperation(onUpdateProcessJob)).subscribe({
                next: (eventData) => {
                    clearInterval(this.uploadCSVTimer)
                    if (eventData !== undefined && eventData.value !== undefined && eventData.value.data.onUpdateProcessJob !== null &&
                        eventData.value.data.onUpdateProcessJob.status === 1) {
                        this.clearData()
                        this.setDataFromCurrentActiveCategorie()
                        this.csvUploadMessage = this.$t("csv_upload_success")
                    } else {
                        this.csvUploadMessage = this.$t("csv_upload_error")

                    }
                },
            });
        },
        async submitFormSearch() {
            if (this.mutationBusy) return
            this.isBusy = true
            this.clearData()
            const activeCategory = this.getCurrentActiveCategorie()
            if (activeCategory && activeCategory.customerFlag) {
                if (this.$refs.ledgerForm) {
                    this.form = this.$refs.ledgerForm.beforeSubmit()
                }
                await this.fetchCustomerMasterData(activeCategory.label)
            } else {
                this.fetchMasterData()
            }
        },
        async setCategorieActive(categorieClicked) {
            if (this.mutationBusy) return
            const currentActiveCategorie = this.getCurrentActiveCategorie();
            if (categorieClicked.label !== currentActiveCategorie.label) {
                this.clearData()
                this.masterCount = null
                this.sortBy = []
            } else {
                return
            }
            const isCurrent = this.captureRead('search')
            currentActiveCategorie.isActive = false;
            categorieClicked.isActive = true
            this.form = null
            if (categorieClicked.customerFlag) {
                this.setCustomerFormFields(categorieClicked.searchFields || [])
            } else {
                this.formItems = categorieClicked.label === 'item' ? this.itemMasterFormItems : []
                this.getOption()
            }
            this.isBusy = true
            await this.getItemHeaders(categorieClicked);
            if (!isCurrent()) return
            await this.$nextTick()
            if (!isCurrent()) return
            this.setCategoryAndfetchData(categorieClicked);

        },
        async setDataFromCurrentActiveCategorie() {
            const isCurrent = this.captureRead('search')
            const currentActiveCategorie = this.getCurrentActiveCategorie();
            currentActiveCategorie.isActive = true
            await this.getItemHeaders(currentActiveCategorie);
            if (!isCurrent()) return
            this.setCategoryAndfetchData(currentActiveCategorie);

        },
        getCurrentActiveCategorie() {
            return this.categories.find(categorie => categorie.isActive === true);
        },
        async getItemHeaders(currentActiveCategorie) {
            const isCurrent = this.captureRead('search')
            if (currentActiveCategorie.label === "item" && this.categories[0].isActive) {
                const response = await AwsApi.graphql({
                    query: queries.queryHeadersWithTable,
                    variables: {
                        tenantId: this.tenantId,
                        sourceTable: "ItemMaster"
                    }
                }, this);
                if (!isCurrent()) return
                if (response === undefined) {
                    return
                }
                this.headers = response.data.queryItemDefines.items.map(item => {
                    const datas = item.source.split('.')
                    var itemKey = ""
                    if (datas.length == 2) {
                        itemKey = datas[1]
                    } else if (datas.length == 3) {
                        itemKey = datas[2]
                    }
                    return {
                        key: itemKey, //item.itemKey !== null ? item.itemKey : item.name,
                        label: item.name,
                        id: item.order, //item.id
                        source: item.source,
                        inputType: item.inputType
                    }
                }).sort(function (first, second) {
                    return first['id'] - second['id']
                });

                this.headers = [...currentActiveCategorie.header, ...this.headers]
            } else {
                this.headers = currentActiveCategorie.header
            }
        },
        setCategoryAndfetchData(categorie) {
            const isCurrent = this.captureRead('search')
            this.isBusy = true
            categorie.isActive = true;
            this.currentData = []
            switch (categorie.label) {
                case "item": {
                    this.fetchMasterData()
                    break;
                }
                case "warehouse": {
                    this.fetchWarehouseData()
                    break;
                }
                case "location": {
                    this.loadWarehousesOption().then(() => {
                        if (!isCurrent()) return
                        this.fetchLocationData()
                    })
                    break;
                }
                default: {
                    this.fetchCustomerMasterData(categorie.label)
                }
            }
        },
        async fetchMenuSettings() {
            const response = await AwsApi.graphql({
                query: queries.getMenu,
                variables: {
                    tenantId: this.tenantId,
                    id: parseInt(this.$route.params.id)
                }
            }, this);
            if (response === undefined) {
                return
            }
            const menu = response.data.getMenu
            if (menu === null) {
                return
            }
            this.customerTableName = (menu.customerTableName || '').trim()
            if (this.customerMasterMode) {
                return menu
            }
            const menuConfigs = menu.configs?.items || []
            if (menuConfigs.length === 0) {
                return menu
            }
            this.itemMasterFormItems = this.buildFormFields(menuConfigs)
            const activeCategory = this.getCurrentActiveCategorie()
            if (activeCategory && activeCategory.customerFlag) {
                return menu
            }
            this.formItems = this.itemMasterFormItems
            this.getOption()
            return menu
        },
        async initializeCustomerMasterMenu() {
            this.isBusy = true
            const menu = await this.fetchMenuSettings()
            const tableName = this.customerTableName
            const category = {
                label: tableName,
                name: menu?.name || tableName,
                isActive: true,
                customerFlag: true,
                header: [],
                url: { delete: mutations.deleteCustomerMaster }
            }
            this.categories = [category]
            if (!tableName) {
                this.headers = []
                this.isBusy = false
                return
            }
            const response = await AwsApi.graphql({
                query: queries.queryHeadersWithTable,
                variables: { tenantId: this.tenantId, sourceTable: tableName }
            }, this)
            if (response === undefined) {
                this.isBusy = false
                return
            }
            const itemDefines = response.data.queryItemDefines.items || []
            this.headers = itemDefines.map(item => {
                const parts = item.source.split('.')
                return {
                    key: parts[parts.length - 1],
                    label: item.name,
                    id: item.order,
                    source: item.source,
                    inputType: item.inputType
                }
            }).sort((a, b) => a.id - b.id)
            category.header = this.headers
            await this.fetchCustomerMasterData(tableName)
        },
        setCustomerFormFields(itemDefines) {
            this.formItems = this.buildFormFields(itemDefines.map(item => ({
                ...item,
                id: item.source,
                sourceDefine: item
            })))
            this.getOption()
        },
        buildFormFields(configs) {
            return configs
                .filter(item => item.searchOrder > 0)
                .sort((a, b) => a.searchOrder - b.searchOrder)
                .map(item => ({
                    id: item.id,
                    title: item.name,
                    type: this.getType(item.sourceDefine),
                    options: item.source,
                    sourceDefine: item.sourceDefine
                }))
        },
        getType(sourceDefine) {
            // get the type
            if (!sourceDefine || sourceDefine.inputType == null) {
                return 'input'
            }
            switch (sourceDefine.inputType) {
                case 1:
                    return 'multi_select'
                case 2:
                    return 'date_range'
                case 3:
                    return 'select'
                case 4:
                    return 'datetime_range'
                case 5:
                    return 'checkbox'
                case 6:
                    return 'checkbox_and_date'
                case 7:
                    return 'url'
                default:
                    return 'input'
            }
        },
        getOption() {
            const optionsBySource = {}
            this.formItems.forEach(item => {
                if (item.type !== 'multi_select' || item.sourceDefine?.items == null) {
                    return
                }
                try {
                    optionsBySource[item.options] = Object.entries(JSON.parse(item.sourceDefine.items)).map(([key, value]) => ({
                        text: value,
                        value: key
                    }))
                } catch (error) {
                    optionsBySource[item.options] = []
                }
            })
            this.form_select_options = optionsBySource
        },
        setRequestParam() {
            const myInit = {
                limit: this.limit,
                offset: this.offset,
                ...this.setCountRequestParam()
            };
            return myInit
        },
        setCountRequestParam() {
            const myInit = {
                
            };
            for (const key in this.form) {
                const hasKey = this.formItems.some(i => i.options === key)
                const isDate = this.formItems.some(i => i.sourceDefine && (i.sourceDefine.inputType === 2 || i.sourceDefine.inputType === 4 || i.sourceDefine.inputType === 6) && i.options === key)
                if (hasKey) {
                    if (this.form[key] !== null && this.form[key] !== '') {
                        if (typeof (this.form[key]) === "boolean") {
                            if (this.form[key] === true) {
                                myInit[key] = this.form[key]
                            }
                        } else if (typeof (this.form[key]) == "string" && !isDate) {
                            myInit[key] = "%" + this.form[key] + "%"
                        } else {
                            myInit[key] = this.form[key]
                        }

                    }
                }
            }
            return myInit
        },
        async getItemsCount(){
            const isCurrent = this.captureRead('search')
            const myInit = this.setCountRequestParam()
            const response = await AwsApi.graphql({
                query: queries.getItemsCount,
                variables: {
                    tableName: "ItemMaster",
                    conditions: JSON.stringify(myInit)
                }
            }, this);
            if (!isCurrent()) return
            if (response?.data?.getItemsCount == null) return
            this.masterCount = response.data.getItemsCount
        },
        async getCustomItemsCount(tableName){
            const isCurrent = this.captureRead('search')
            const myInit = this.setCountRequestParam()
            const response = await AwsApi.graphql({
                query: queries.getItemsCount,
                variables: {
                    tableName: tableName,
                    conditions: JSON.stringify(myInit)
                }
            }, this);
            if (!isCurrent()) return
            if (response?.data?.getItemsCount == null) return
            this.masterCount = response.data.getItemsCount
        },
        async fetchMasterData() {
            const isCurrent = this.captureRead('search')
            console.log("fetchMasterData....")
            if (this.$refs.ledgerForm) {
                this.form = this.$refs.ledgerForm.beforeSubmit()
            }
            const myInit = this.setRequestParam()
            const response = await AwsApi.graphql({
                query: queries.getItemMasterList,
                variables: {
                    conditions: JSON.stringify(myInit)
                }
            }, this);
            if (!isCurrent()) return
            if (response === undefined) {
                this.isBusy = false
                return
            }
            if (!this.categories[0].isActive) {
                return
            }

            const convertData = response.data.getItemMasterList.map(item => {
                return JSON.parse(item)
            })
            this.allData = this.allData.concat(convertData);
            this.setData();
            if (this.dataChangeFlag) {
                this.dataChangeFlag = false
                this.currentPage = 1
            }
            this.isBusy = false
            this.getItemsCount()
        },
        setData() {
            this.sortData()
            if (this.categories[0].isActive) {
                this.currentData = this.allData.slice((this.currentPage - 1) * this.count, this.currentPage * this.count).map(item => {
                    var jsonProperties = {}
                    try {
                        jsonProperties = JSON.parse(item.properties)
                    } catch (error) {}
                    return {
                        ...item,
                        ...jsonProperties
                    }
                })
            } else {
                this.currentData = this.allData.slice((this.currentPage - 1) * this.count, this.currentPage * this.count)
                this.currentData = this.currentData.map(item => {
                    return {
                        ...item,
                        imageLoadFlag: false
                    }
                })
                this.currentData.forEach(async item => {
                    item.signedURL = await this.getMap(item.upload)
                    item.imageLoadFlag = true
                })

            }
            this.pagination.totalRow = this.allData.length;
            this.pagination.perPage = this.count;
            if (!this.modalCreate) {
                this.modalItemData = this.currentData.map(a => ({
                    ...a
                }));
            }
        },
        sortChange(value) {
            if (this.mutationBusy) return
            const header = this.headers.find(item => item.key === value || item.source === value)
            if (header === undefined || header.key === "map") {
                return
            }

            const exist = this.sortBy.map(item => item.key).includes(header.key)
            this.sortBy = exist ?
                this.sortBy.map(item => {
                    if (item.key === header.key) {
                        item.direction = item.direction === 'asc' ? 'desc' : 'asc'
                    }
                    return item
                }) : [{
                    key: header.key,
                    source: header.source,
                    direction: 'asc'
                }]
            this.setData()
        },
        sortData() {
            if (this.sortBy.length === 0) {
                return
            }

            const sort = this.sortBy[0]
            this.allData.sort((a, b) => {
                const valA = this.getSortValue(a, sort)
                const valB = this.getSortValue(b, sort)

                if (valA == null && valB == null) return 0
                if (valA == null) return sort.direction === "asc" ? 1 : -1
                if (valB == null) return sort.direction === "asc" ? -1 : 1

                const normalizedA = this.normalizeSortValue(valA)
                const normalizedB = this.normalizeSortValue(valB)
                let result = 0

                if (typeof normalizedA === "number" && typeof normalizedB === "number") {
                    result = normalizedA === normalizedB ? 0 : (normalizedA < normalizedB ? -1 : 1)
                } else {
                    result = String(normalizedA).localeCompare(String(normalizedB), undefined, {
                        numeric: true,
                        sensitivity: 'base'
                    })
                }

                return sort.direction === "asc" ? result : -result
            })
        },
        getSortValue(item, sort) {
            if (item === undefined || item === null) {
                return null
            }

            if (Object.prototype.hasOwnProperty.call(item, sort.key)) {
                return item[sort.key]
            }

            if (sort.source && Object.prototype.hasOwnProperty.call(item, sort.source)) {
                return item[sort.source]
            }

            const sourceKey = sort.source ? sort.source.split('.').pop() : null
            if (sourceKey && Object.prototype.hasOwnProperty.call(item, sourceKey)) {
                return item[sourceKey]
            }

            if (item.properties === undefined || item.properties === null) {
                return null
            }

            try {
                const properties = typeof item.properties === "string" ? JSON.parse(item.properties) : item.properties
                if (Object.prototype.hasOwnProperty.call(properties, sort.key)) {
                    return properties[sort.key]
                }
                if (sourceKey && Object.prototype.hasOwnProperty.call(properties, sourceKey)) {
                    return properties[sourceKey]
                }
            } catch (error) {
                return null
            }

            return null
        },
        normalizeSortValue(value) {
            if (Array.isArray(value)) {
                return value.join(',')
            }
            if (typeof value === "boolean") {
                return value ? 1 : 0
            }
            if (typeof value === "number") {
                return value
            }

            const stringValue = String(value).trim()
            if (stringValue !== '') {
                const numberValue = Number(stringValue)
                if (!Number.isNaN(numberValue)) {
                    return numberValue
                }
            }

            return stringValue
        },
        getSortDirection(key) {
            const sort = this.sortBy.find(item => item.key === key)
            return sort ? sort.direction : undefined
        },
        getHeadSortDirection(data) {
            const key = data?.field?.key || data?.column || this.headers.find(item => item.label === data?.label)?.key
            return this.getSortDirection(key)
        },
        updatePage() {
            if (this.currentPage * this.count >= this.limit + this.offset) {
                this.offset += this.limit
                const currentActiveCategorie = this.getCurrentActiveCategorie();
                if (currentActiveCategorie.label !== "location") {
                    this.setCategoryAndfetchData(currentActiveCategorie);
                } else {
                    this.setData()
                }
            } else {
                this.setData()
            }
        },
        async listWarehousesAPI(tab) {
            const isCurrent = this.captureRead('search')
            let nextToken = null
            let allItems = []

            do {
                const response = await AwsApi.graphql({
                    query: queries.listWarehouses,
                    variables: {
                        tenantId: this.tenantId,
                        nextToken: nextToken
                    }
                }, this)
                if (!isCurrent()) return

                if (!response) break

                if (this.getCurrentActiveCategorie().label !== tab) {
                    return []
                }

                const data = response.data.listWarehouses
                allItems = allItems.concat(data.items)
                nextToken = data.nextToken

            } while (nextToken)
            return allItems
        },
        async fetchWarehouseData() {
            const isCurrent = this.captureRead('search')
            this.currentData = []
            const warehouses = await this.listWarehousesAPI("warehouse")
            if (!isCurrent()) return
            this.allData = warehouses
            this.isBusy = false
            this.setData();
            if (this.dataChangeFlag) {
                this.dataChangeFlag = false
                this.currentPage = 1
            }
            this.isBusy = false
        },
        async fetchLocationData() {
            const isCurrent = this.captureRead('search')
            this.currentData = []
            if (!this.warehouseSelect && this.listWarehouses.length !== 0) {
                this.warehouseSelect = this.listWarehouses[0].value;
                return
            }
            this.listLocations = []
            this.listLocationTags = []
            await this.getListLocations(this.warehouseSelect, undefined)
            if (!isCurrent()) return
            await this.getListLocationTags(this.warehouseSelect, undefined)
            if (!isCurrent()) return

            if (this.getCurrentActiveCategorie().label !== "location") {
                return
            }
            const warehouse = this.listWarehouses.find(warehouse => warehouse.value === this.warehouseSelect)
            const showLists = this.listLocations.map(item => {
                return {
                    ...item,
                    warehouseId: warehouse.text,
                    epc: this.listLocationTags.filter(itemTag => itemTag.location_id === item.id).map(item => item.epc)

                }
            })
            this.allData = this.allData.concat(showLists);
            this.allData = this.allData.sort(function (a, b) {
                return a.number - b.number
            })
            this.setData();
            if (this.dataChangeFlag) {
                this.dataChangeFlag = false
                this.currentPage = 1
            }
            this.isBusy = false
        },
        async getListLocations(warehouseId, nextTokenValue) {
            return this.loadReadList('listLocations', queries.queryLocationsByWarehouseId, 'queryLocationsByWarehouseId', {
                tenantId: this.tenantId,
                warehouseId: { eq: warehouseId },
                limit: this.limit,
                nextToken: nextTokenValue
            }, 'search')
        },
        async getListLocationTags(warehouseId, nextTokenValue) {
            return this.loadReadList('listLocationTags', queries.queryLocationTagsByWarehouseId, 'queryLocationTagsByWarehouseId', {
                tenantId: this.tenantId,
                warehouseId: { eq: warehouseId },
                limit: this.limit,
                nextToken: nextTokenValue
            }, 'search')
        },
        openModalCreateRow(evt) {
            if (this.mutationBusy) return
            this.modalItemData = []
            this.modalCreate = true;
            this.ledgerModal = true
        },
        openModalUpdateRow(evt) {
            if (this.mutationBusy) return
            this.modalItemData = this.currentData.map(a => {
                if (a["searchFinishedFlag"] !== undefined && a["searchFinishedFlag"] !== null) {
                    if (a["searchFinishedFlag"] === 1) {
                        a["searchFinishedFlag"] = true
                    } else if (a["searchFinishedFlag"] === 0) {
                        a["searchFinishedFlag"] = false
                    }
                }
                if (!a.hasOwnProperty("id")) {
                    a.id = uuidv4()
                }
                return {
                    ...a
                }
            });
            this.modalCreate = false;
            this.ledgerModal = true
        },
        async onclickAddItem() {
            if (this.mutationBusy) return
            const item = await this.newItemToAdd();
            this.modalItemData.push(item);
        },
        onclickItemUpdate() {
            if (this.mutationBusy) return
            const currentActiveCategorie = this.getCurrentActiveCategorie();
            if (this.customerMasterMode) {
                this.apiUpdateCustomerMaster(this.customerTableName)
                return
            }
            switch (currentActiveCategorie.label) {
                case "item": {
                    this.apiUpdateOrCreateItem()
                    break;
                }
                case "warehouse": {
                    this.apiUpdateOrCreateWarehouses()
                    break;
                }
                case "location": {
                    this.apiUpdateLocations()
                    break;
                }
                default: {
                    this.apiUpdateCustomerMaster(currentActiveCategorie.label)
                }
            }
        },
        mutationFailed(result, field) {
            return !result || (result.errors && result.errors.length > 0) ||
                !result.data || result.data[field] == null || result.data[field] < 0
        },
        async withMutationLock(action, messageKey) {
            if (this.mutationBusy) return
            this.mutationBusy = true
            let operation
            try {
                // checkSession does not return the callback's promise.
                await AwsApi.checkSession(() => {
                    operation = Promise.resolve().then(action)
                    operation.catch(() => {})
                }, this)
                return operation ? await operation : undefined
            } catch (error) {
                if (messageKey === "csv_dl_error") {
                    this.csvUploadMessage = this.$t(messageKey)
                    this.showOverlay = true
                } else if (messageKey) this.showSaveFailed(messageKey)
                else this.modalAlertDeleteFailed = true
            } finally {
                this.mutationBusy = false
            }
        },
        onHideLedgerModal(event) {
            if (this.mutationBusy && this.ledgerModal) {
                event.preventDefault()
                return
            }
            this.removeNewItems()
        },
        showSaveFailed(messageKey) {
            this.saveFailedMessageKeys = [messageKey]
            this.modalAlertSaveFailed = true
        },
        async settleMutations(requests, items, field) {
            const results = await Promise.allSettled(requests)
            return items.filter((item, index) => results[index].status === 'rejected' ||
                this.mutationFailed(results[index].value, field))
        },
        retainFailedSaves(items, failedItems, creating) {
            const succeeded = new Set(items.filter(item => !failedItems.includes(item)))
            if (creating) {
                this.modalItemData = this.modalItemData.filter(item => !succeeded.has(item))
            } else {
                succeeded.forEach(item => {
                    delete item.toCreate
                    delete item.toUpdate
                })
            }
            this.selection = this.selection.filter(item => !succeeded.has(item))
        },
        async apiUpdateOrCreateItem() {
            return this.withMutationLock(() => {
                const create = [];
                const update = [];
                const _this = this
                const creating = this.modalCreate
                const items = creating ? [...this.modalItemData] : this.modalItemData.filter(item => item.toUpdate)
                if (this.modalCreate) {
                    this.modalItemData.forEach(item => {
                        const json = _this.createSendJson(item)
                        create.push(API.graphql({
                            query: mutations.createItemMaster,
                            variables: {
                                createItemMaster: JSON.stringify(json)
                            }
                        }));
                    })
                } else {
                    const itemsToUpdate = this.modalItemData.filter(item => item.toUpdate);
                    itemsToUpdate.forEach(item => {
                        const json = _this.createSendJson(item)
                        json['id'] = item.id
                        update.push(API.graphql({
                            query: mutations.updateItemMaster,
                            variables: {
                                updateItemMaster: JSON.stringify(json)
                            }
                        }));
                    })
                }
                return this.settleMutations([...create, ...update], items, creating ? "createItemMaster" : "updateItemMaster").then((failed) => {
                    this.retainFailedSaves(items, failed, creating)
                    if (failed.length) {
                        this.showSaveFailed(creating ? "data_insertion_failed" : "data_update_failed")
                        return
                    }
                    this.isBusy = true
                    this.clearData()
                    this.fetchMasterData()
                    this.ledgerModal = false
                    this.removeNewItems()
                }).catch(() => {
                    this.showSaveFailed(creating ? "data_insertion_failed" : "data_update_failed")
                })
            }, this.modalCreate ? "data_insertion_failed" : "data_update_failed")
        },
        createSendJson(item) {
            const json = {}
            console.log("-------")
            this.headers.forEach((h) => {
                const sources = h.source.split(".")
                if (sources.length == 2) {
                    if (item[sources[1]] !== undefined) {
                        json[sources[1]] = item[sources[1]]
                    }
                    const pre = {}
                    pre[h.label] = item[sources[1]]
                    json['properties'] = {
                        ...json['properties'],
                        ...pre
                    }
                } else if (sources.length == 3) {
                    if (item[sources[2]] !== undefined) {
                        const pre = {}
                        pre[sources[2]] = item[sources[2]]
                        json['properties'] = {
                            ...json['properties'],
                            ...pre
                        }
                    }

                }
            })
            if (json['properties'] !== undefined) {
                json['properties'] = JSON.stringify(json['properties'])
            }
            return json
        },
        async apiUpdateOrCreateWarehouses() {
            return this.withMutationLock(async () => {
                const creating = this.modalCreate
                const items = creating ? [...this.modalItemData] : this.modalItemData.filter(item => item.toUpdate)
                const create = [];
                const update = [];
                if (this.modalCreate) {
                    this.modalItemData.forEach(item => {
                        if (item.rssi_threshhold === "") {
                            item.rssi_threshhold = null
                        }
                        if (item.product_rssi_threshhold === "") {
                            item.product_rssi_threshhold = null
                        }
                        if (item.state_change_interval === "") {
                            item.state_change_interval = null
                        }
                        if (item.all_shelves_scan_percentage === "") {
                            item.all_shelves_scan_percentage = null
                        }
                        if (item.robot_home_x === "") {
                            item.robot_home_x = null
                        }
                        if (item.robot_home_y === "") {
                            item.robot_home_y = null
                        }
                        if (item.robot_stop_meters === "") {
                            item.robot_stop_meters = null
                        }
                        if (item.robot_stop_seconds === "") {
                            item.robot_stop_seconds = null
                        }
                        if (item.robot_distance === "") {
                            item.robot_distance = null
                        }
                        if (item.robot_orientation === "") {
                            item.robot_orientation = null
                        }

                        if (item.shelf_transparency === "") {
                            item.shelf_transparency = null
                        }

                        if (item.item_tag_filter === undefined || item.item_tag_filter === null) {
                            item.item_tag_filter = ""
                        }

                        if (item.location_tag_filter === undefined || item.location_tag_filter === null) {
                            item.location_tag_filter = ""
                        }

                        var createItem = {
                            group: this.tenantId,
                            tenantId: this.tenantId,
                            id: item.id,
                            name: item.name,
                            rssi_threshhold: item.rssi_threshhold,
                            product_rssi_threshhold: item.product_rssi_threshhold,
                            real_width: item.real_width,
                            real_height: item.real_height,
                            item_tag_filter: item.item_tag_filter,
                            location_tag_filter: item.location_tag_filter,
                            state_change_interval: item.state_change_interval,
                            all_shelves_scan_percentage: item.all_shelves_scan_percentage,
                            remarks: item.remarks,
                            robot_home_x: item.robot_home_x,
                            robot_home_y: item.robot_home_y,
                            robot_stop_meters: item.robot_stop_meters,
                            robot_stop_seconds: item.robot_stop_seconds,
                            robot_distance: item.robot_distance,
                            robot_orientation: item.robot_orientation,
                            shelf_transparency: item.shelf_transparency

                        }
                        create.push(API.graphql({
                            query: mutations.createWarehouse,
                            variables: {
                                input: createItem
                            }
                        }));
                    })
                } else {
                    const itemsToUpdate = this.modalItemData.filter(item => item.toUpdate);
                    itemsToUpdate.forEach(item => {
                        if (item.rssi_threshhold === "") {
                            item.rssi_threshhold = null
                        }
                        if(item.product_rssi_threshhold === ""){
                           item.product_rssi_threshhold = null
                        }
                        if (item.state_change_interval === "") {
                            item.state_change_interval = null
                        }
                        if (item.all_shelves_scan_percentage === "") {
                            item.all_shelves_scan_percentage = null
                        }
                        if (item.robot_home_x === "") {
                            item.robot_home_x = null
                        }
                        if (item.robot_home_y === "") {
                            item.robot_home_y = null
                        }
                        if (item.robot_stop_meters === "") {
                            item.robot_stop_meters = null
                        }
                        if (item.robot_stop_seconds === "") {
                            item.robot_stop_seconds = null
                        }
                        if (item.robot_distance === "") {
                            item.robot_distance = null
                        }
                        if (item.robot_orientation === "") {
                            item.robot_orientation = null
                        }
                        if (item.shelf_transparency === "") {
                            item.shelf_transparency = null
                        }

                        if (item.item_tag_filter === undefined || item.item_tag_filter === null) {
                            item.item_tag_filter = ""
                        }

                        if (item.location_tag_filter === undefined || item.location_tag_filter === null) {
                            item.location_tag_filter = ""
                        }

                        var updateItem = {
                            tenantId: this.tenantId,
                            id: item.id,
                            name: item.name,
                            item_tag_filter: item.item_tag_filter,
                            location_tag_filter: item.location_tag_filter,
                            all_shelves_scan_percentage: item.all_shelves_scan_percentage,
                            rssi_threshhold: item.rssi_threshhold,
                            product_rssi_threshhold: item.product_rssi_threshhold,
                            state_change_interval: item.state_change_interval,
                            robot_home_x: item.robot_home_x,
                            robot_home_y: item.robot_home_y,
                            robot_stop_meters: item.robot_stop_meters,
                            robot_stop_seconds: item.robot_stop_seconds,
                            robot_distance: item.robot_distance,
                            robot_orientation: item.robot_orientation,
                            shelf_transparency: item.shelf_transparency,
                            remarks: item.remarks
                        }
                        update.push(API.graphql({
                            query: mutations.updateWarehouse,
                            variables: {
                                input: updateItem
                            }
                        }));
                    })
                }
                return this.settleMutations([...create, ...update], items, creating ? "createWarehouse" : "updateWarehouse").then((failed) => {
                    this.retainFailedSaves(items, failed, creating)
                    if (failed.length) {
                        this.showSaveFailed(creating ? "data_insertion_failed" : "data_update_failed")
                        return
                    }
                    this.clearData()
                    this.isBusy = true
                    this.fetchWarehouseData()
                    this.ledgerModal = false
                    this.removeNewItems()
                    this.$bus.emit('fetchWarehouse');
                }).catch(() => {
                    this.showSaveFailed(creating ? "data_insertion_failed" : "data_update_failed")
                })

            }, this.modalCreate ? "data_insertion_failed" : "data_update_failed")
        },
        apiUpdateLocations() {
            return this.withMutationLock(() => {
                const update = [];

                const itemsToUpdate = this.modalItemData.filter(item => item.toUpdate);
                itemsToUpdate.forEach(item => {
                    if (item.number === "") {
                        item.number = null
                    }
                    var updateItem = {
                        tenantId: this.tenantId,
                        number: item.number,
                        id: item.id,
                        label: item.label
                    }

                    update.push(API.graphql({
                        query: mutations.updateLocation,
                        variables: {
                            input: updateItem
                        }
                    }));
                })

                return this.settleMutations(update, itemsToUpdate, "updateLocation").then((failed) => {
                    this.retainFailedSaves(itemsToUpdate, failed, false)
                    if (failed.length) {
                        this.showSaveFailed("data_update_failed")
                        return
                    }
                    this.clearData()
                    this.isBusy = true
                    this.fetchLocationData()
                    this.ledgerModal = false
                    this.removeNewItems()
                }).catch(() => {
                    this.showSaveFailed("data_update_failed")
                })
            }, this.modalCreate ? "data_insertion_failed" : "data_update_failed")
        },
        apiUpdateCustomerMaster(tableName) {
            return this.withMutationLock(() => {
                const creating = this.modalCreate
                const messageKey = creating ? "data_insertion_failed" : "data_update_failed"
                const update = [];

                const items = this.modalItemData.filter(item => item.toCreate || item.toUpdate);
                items.forEach(item => {
                    const master = { ...item }
                    delete master["toCreate"]
                    delete master["toUpdate"]
                    delete master["signedURL"]
                    delete master["imageLoadFlag"]
                    update.push(API.graphql({
                        query: mutations.updateCustomerMaster,
                        variables: {
                            tableName: tableName,
                            master: JSON.stringify(master)
                        }
                    }));
                })

                return this.settleMutations(update, items, "updateCustomerMaster").then((failed) => {
                    this.retainFailedSaves(items, failed, creating)
                    if (failed.length) {
                        this.saveFailedMessageKeys = [messageKey]
                        this.modalAlertSaveFailed = true
                        return
                    }
                    this.clearData()
                    this.isBusy = true
                    this.fetchCustomerMasterData(tableName)
                    this.ledgerModal = false
                    this.removeNewItems()
                }).catch(() => {
                    this.saveFailedMessageKeys = [messageKey]
                    this.modalAlertSaveFailed = true
                })
            }, this.modalCreate ? "data_insertion_failed" : "data_update_failed")
        },
        onclickItemDelete() {
            if (this.mutationBusy) return
            const currentActiveCategorie = this.getCurrentActiveCategorie();
            if (this.customerMasterMode) {
                this.deleteCustomerMasterData(this.customerTableName)
                return
            }
            if (currentActiveCategorie.label === "warehouse") {
                this.modalAlertDeleteWarehouse = true
            } else if (currentActiveCategorie.label === "location") {
                this.modalAlertDeleteLocation = true
            } else {
                switch (currentActiveCategorie.label) {
                    case "item": {
                        this.deleteDataFun()
                        break;
                    }
                    default: {
                        this.deleteCustomerMasterData(currentActiveCategorie.label)
                    }
                }

            }
        },
        deleteDataFun() {
            if (this.mutationBusy) return
            if (this.modalCreate) {
                this.selection.forEach((item, index) => {
                    this.modalItemData = this.modalItemData.filter(data => data.id !== item.id)
                })
                return
            }
            const currentActiveCategorie = this.getCurrentActiveCategorie();
            this.apiDeleteSelection(currentActiveCategorie)
        },
        applyDeletedItems(items, failed) {
            const succeededIds = new Set(items.filter(item => !failed.includes(item)).map(item => item.id))
            this.allData = this.allData.filter(item => !succeededIds.has(item.id))
            this.currentData = this.currentData.filter(item => !succeededIds.has(item.id))
            this.modalItemData = this.modalItemData.filter(item => !succeededIds.has(item.id))
            this.selection = this.selection.filter(item => !succeededIds.has(item.id))
            this.pagination.totalRow = this.allData.length
            if (this.currentSelect && succeededIds.has(this.currentSelect.id)) this.currentSelect = null
        },
        async apiDeleteSelection(currentActiveCategorie) {
            return this.withMutationLock(() => {
                const items = [...this.selection]
                const label = currentActiveCategorie.label
                const field = { item: "deleteItemMaster", warehouse: "deleteWarehouse", location: "deleteLocation" }[label]
                const requests = items.map(async item => {
                    if (label === "warehouse") await this.deleteAllLocationTag(item.id)
                    if (label === "location") await this.deleteLocationTags(item.id)
                    return API.graphql({
                        query: currentActiveCategorie.url.delete,
                        variables: label === "item" ? { id: item.id } : { input: { tenantId: this.tenantId, id: item.id } }
                    })
                })
                return this.settleMutations(requests, items, field).then(failed => {
                    this.applyDeletedItems(items, failed)
                    if (label === "warehouse" && failed.length < items.length) this.$bus.emit('fetchWarehouse')
                    if (failed.length) {
                        this.modalAlertDeleteFailed = true
                        return
                    }
                    if (label === "item") {
                        this.isBusy = true
                        this.clearData()
                        this.fetchMasterData()
                        this.ledgerModal = false
                        this.removeNewItems()
                    }
                }).catch(() => {
                    this.modalAlertDeleteFailed = true
                })
            })
        },
        async deleteCustomerMasterData(tableName) {
            if (this.mutationBusy) return
            if (this.modalCreate) {
                this.modalItemData = this.modalItemData.filter(item => !this.selection.includes(item))
                this.selection = []
                return
            }
            return this.withMutationLock(() => {
                const items = [...this.selection]
                const requests = items.map(item => API.graphql({
                    query: mutations.deleteCustomerMaster,
                    variables: { tableName, master: JSON.stringify({ id: item.id }) }
                }))
                return this.settleMutations(requests, items, "deleteCustomerMaster").then(failed => {
                    this.applyDeletedItems(items, failed)
                    if (failed.length) {
                        this.modalAlertDeleteFailed = true
                        return
                    }
                    this.isBusy = true
                    this.clearData()
                    this.fetchCustomerMasterData(tableName)
                    this.ledgerModal = false
                    this.removeNewItems()
                }).catch(() => {
                    this.modalAlertDeleteFailed = true
                })
            })
        },
        async deleteLocationTags(locationId) {
            const tags = []
            let nextToken
            do {
                const result = await API.graphql({
                    query: queries.listLocationTags,
                    variables: {
                        tenantId: this.tenantId,
                        filter: { location_id: { eq: locationId } },
                        limit: this.limit,
                        nextToken
                    }
                })
                if (this.mutationFailed(result, "listLocationTags") || !Array.isArray(result.data.listLocationTags.items)) {
                    throw new Error("listLocationTags failed")
                }
                tags.push(...result.data.listLocationTags.items)
                nextToken = result.data.listLocationTags.nextToken
            } while (nextToken)
            const failed = await this.settleMutations(tags.map(tag => API.graphql({
                query: mutations.deleteLocationTag,
                variables: { input: { tenantId: this.tenantId, id: tag.id } }
            })), tags, "deleteLocationTag")
            if (failed.length) throw new Error("deleteLocationTag failed")
            this.listLocationTags = this.listLocationTags.filter(tag => tag.location_id !== locationId)
        },
        async deleteAllLocationTag(warehouseId) {
            const loadItems = async (query, field) => {
                const items = []
                let nextToken
                do {
                    const result = await API.graphql({
                        query,
                        variables: { tenantId: this.tenantId, warehouseId: { eq: warehouseId }, limit: this.limit, nextToken }
                    })
                    if (this.mutationFailed(result, field) || !Array.isArray(result.data[field].items)) {
                        throw new Error(field + " failed")
                    }
                    items.push(...result.data[field].items)
                    nextToken = result.data[field].nextToken
                } while (nextToken)
                return items
            }
            const [locations, tags] = await Promise.all([
                loadItems(queries.queryLocationsByWarehouseId, "queryLocationsByWarehouseId"),
                loadItems(queries.queryLocationTagsByWarehouseId, "queryLocationTagsByWarehouseId")
            ])
            const entries = [
                ...locations.map(item => ({ item, query: mutations.deleteLocation, field: "deleteLocation" })),
                ...tags.map(item => ({ item, query: mutations.deleteLocationTag, field: "deleteLocationTag" }))
            ]
            const results = await Promise.allSettled(entries.map(async entry => {
                const result = await API.graphql({
                    query: entry.query,
                    variables: { input: { tenantId: this.tenantId, id: entry.item.id } }
                })
                if (this.mutationFailed(result, entry.field)) throw new Error(entry.field + " failed")
            }))
            if (results.some(result => result.status === 'rejected')) throw new Error("Warehouse cleanup failed")
        },
        updateItem(value, item, key) {
            if (this.mutationBusy) return
            if (typeof value === 'string') {
                if (value.includes("\t")) {
                    value = value.replace('\t', '')
                }
                if (value.includes("\\t")) {
                    value = value.replace('\\\\t', '').replace('\\t', '')
                }
            }
            if (this.modalCreate) {
                const items = [...this.modalItemData];
                const itemToCreate = items.find(i => i.id === item.id);
                itemToCreate[key] = value;
            } else {
                const items = [...this.modalItemData];
                const itemToUpdate = items.find(i => i.id === item.id);
                itemToUpdate[key] = value;
                itemToUpdate.toUpdate = true
            }
        },
        async newItemToAdd() {
            const categorie = this.getCurrentActiveCategorie().label
            let item = null
            switch (categorie) {
                case 'item':
                    item = {
                        id: uuidv4(),
                        toCreate: true,
                    };
                    break;
                case 'warehouse':
                    if (this.tmpId === 0) {
                        const list = await this.listWarehousesAPI("warehouse")
                        if (list.length >= 2) {
                            this.tmpId = list.reduce((a, b) => {
                                return Number(a.id) > Number(b.id) ? a : b
                            }).id
                        } else if (list.length === 1) {
                            this.tmpId = list[0].id
                        }
                    }

                    this.tmpId = this.tmpId + 1
                    item = {
                        name: `${this.$t("warehouse")}`,
                        id: this.tmpId,
                        toCreate: true,
                    };
                    break;
                default:
                    item = {
                        id: uuidv4(),
                        toCreate: true,
                    };
            }

            return item;
        },
        removeNewItems() {
            this.modalItemData = []
            this.selection = []
            this.currentSelect = null
            this.selectAll = false
            this.tmpId = 0
        },
        async loadWarehousesOption() {
            const isCurrent = this.captureRead('search')
            const list = await this.listWarehousesAPI("location")
            if (!isCurrent()) return
            this.listWarehouses = list.map((item) => ({
                value: item.id,
                text: `${item.name}`,
            }));
        },
        clearData() {
            this.invalidateReads('search')
            this.dataChangeFlag = true
            this.allData = []
            this.currentData = []
            this.offset = 0
            this.pagination = {
                totalRow: 0,
                perPage: 0
            }
        },
        async uploadCSV(csvStr) {
            const categorie = this.getCurrentActiveCategorie();
            var isItemMasterUpload = true
            if (categorie.label === "item") {
                isItemMasterUpload = true
            } else {
                isItemMasterUpload = false
            }

            if (/\.(xlsx)$/i.test(this.$refs.file.files[0].name)) {
                if (isItemMasterUpload) {
                    this.updateCsvPath = `${this.tenantId}/master/${this.$route.query.warehouse}_${global.formatLongDate()}.xlsx`
                } else {
                    this.updateCsvPath = `${this.tenantId}/customer/${categorie.label}_${global.formatLongDate()}.xlsx`
                }
                return await Storage.put(this.updateCsvPath, this.$refs.file.files[0]);
            } else if (/\.(xlsm)$/i.test(this.$refs.file.files[0].name)) {
                if (isItemMasterUpload) {
                    this.updateCsvPath = `${this.tenantId}/master/${this.$route.query.warehouse}_${global.formatLongDate()}.xlsm`
                } else {
                    this.updateCsvPath = `${this.tenantId}/customer/${categorie.label}_${global.formatLongDate()}.xlsm`
                }
                return await Storage.put(this.updateCsvPath, this.$refs.file.files[0]);
            } else {
                if (isItemMasterUpload) {
                    this.updateCsvPath = `${this.tenantId}/master/${this.$route.query.warehouse}_${global.formatLongDate()}.csv`
                } else {
                    this.updateCsvPath = `${this.tenantId}/customer/${categorie.label}_${global.formatLongDate()}.csv`
                }
                return await Storage.put(this.updateCsvPath, csvStr, {
                    contentType: "text/csv",
                });
            }
        },
        clearInput() {
            const input = this.$refs.file
            input.type = 'text'
            input.type = 'file'
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];

            /*
              Check to see if the file is not empty.
            */
            if (this.file) {
                if (/\.(csv)$/i.test(this.file.name)) {
                    this.reader.readAsText(this.file);
                }
                if (/\.(xlsx|xlsm)$/i.test(this.file.name)) {
                    this.reader.readAsArrayBuffer(this.file);
                }
            }
        },
        async downloadCSV(table) {
            this.isCsvBusy = true
            try {
                const rows = await this.getCsvAllListData(table)
                const escapeCsvValue = (value) => {
                    if (value === undefined || value === null) {
                        return ""
                    }

                    const stringValue = String(value)
                    if (/[",\r\n]/.test(stringValue)) {
                        return `"${stringValue.replace(/"/g, '""')}"`
                    }

                    return stringValue
                }
                var csv = ""
                this.headers.forEach((item) => {
                    const label = escapeCsvValue(item.label)
                    if (csv === '') {
                        csv = csv + label
                    } else {
                        csv = csv + ',' + label
                    }
                })
                csv = csv + '\n'
                rows.forEach((item) => {
                    var jsonProperties = {}
                    try {
                        jsonProperties = JSON.parse(item.properties)
                    } catch (error) {}
                    const elements = {
                        ...item,
                        ...jsonProperties
                    }

                    this.headers.forEach((key, index) => {
                        const value = escapeCsvValue(elements[key.key])
                        if (index === 0) {
                            csv = csv + value
                        } else {
                            csv = csv + ',' + value
                        }
                    })
                    csv = csv + '\n'

                })

                let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
                let blob = new Blob([bom, csv], {
                    type: 'text/csv'
                })
                const downloadLink = document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(blob);
                if(table !== undefined){
                    downloadLink.download = table + `.csv`;
                } else {
                    downloadLink.download = `master.csv`;
                }
                downloadLink.click();
            } catch (error) {
                console.error('CSV download failed', error)
            } finally {
                this.isCsvBusy = false
            }

        },
        async getCsvAllListData(table) {
            if (this.$refs.ledgerForm) {
                this.form = this.$refs.ledgerForm.beforeSubmit()
            }
            if (table) {
                return this.getCustomerMasterCsvData(table)
            }

            this.offset += this.limit
            const myInit = this.setRequestParam()

            const response = await AwsApi.graphql({
                query: queries.getItemMasterList,
                variables: {
                    conditions: JSON.stringify(myInit)
                }
            }, this)
            if (!response?.data?.getItemMasterList) {
                return []
            }
            if (response.data.getItemMasterList.length !== 0) {
                const convertData = response.data.getItemMasterList.map(item => {
                    return JSON.parse(item)
                })
                this.allData = this.allData.concat(convertData);
                this.pagination.totalRow = this.allData.length;
                this.pagination.perPage = this.count;
                if (response.data.getItemMasterList.length === 1000) {
                    await this.getCsvAllListData()
                }
            }
            return this.allData
        },
        async getCustomerMasterCsvData(table) {
            const filters = this.setCountRequestParam()
            const rows = []
            let offset = 0

            while (true) {
                const response = await AwsApi.graphql({
                    query: queries.getCustomerMaster,
                    variables: {
                        tableName: table,
                        conditions: JSON.stringify({ limit: this.limit, offset, ...filters })
                    }
                }, this)
                const page = response?.data?.getCustomerMaster
                if (!Array.isArray(page)) {
                    return []
                }

                rows.push(...page.map(item => JSON.parse(item)))
                if (page.length < this.limit) {
                    return rows
                }
                offset += this.limit
            }
        },
        rowSelected(rowSelected) {
            this.currentSelect = rowSelected
        },
        rowUnselected(rowUnselected) {
            this.currentSelect = null
        },
        async getMap(src) {
            var signedURL = ""
            if (src !== undefined && src !== null) {
                if (src.includes("private/")) {
                    signedURL = await Storage.get(src.slice(8), {
                        level: 'private'
                    });
                } else if (src.includes("protected/")) {
                    signedURL = await Storage.get(src.slice(10), {
                        level: 'protected'
                    });
                } else if (src.includes("public/")) {
                    signedURL = await Storage.get(src.slice(7));
                }
            }
            return signedURL
        },
        onclickSelectAll() {
            if (this.mutationBusy) return
            if (this.selectAll) {
                this.selection = this.modalItemData
            } else {
                this.selection = []
            }
        },
        onClickDeleteAll() {
            if (this.mutationBusy) return
            this.modalAlertDeleteMaster = true
        },
        deleteMasterDataFun() {
            return this.withMutationLock(() => API.graphql({
                query: mutations.deleteItemMaster,
                variables: {
                    id: -1
                }
            }).then(result => {
                if (this.mutationFailed(result, "deleteItemMaster")) {
                    this.modalAlertDeleteFailed = true
                    return
                }
                this.clearData()
                this.fetchMasterData()
            }).catch(() => {
                this.modalAlertDeleteFailed = true
            }))
        },
        async downloadWarehouseCsv() {
            if (this.selection.length === 0 || this.csvWorking || this.mutationBusy) return
            const items = [...this.selection]
            this.csvWorking = true
            try {
                await this.withMutationLock(async () => {
                    for (const item of items) {
                        const response = await API.graphql({
                            query: queries.getWarehouse,
                            variables: { tenantId: this.tenantId, id: item.id }
                        })
                        if (!response?.data?.getWarehouse) continue
                        this.listLocations = []
                        this.listLocationTags = []
                        await this.getListLocations(item.id, undefined)
                        await this.getListLocationTags(item.id, undefined)
                        this.createCSVWarehouseLink(response.data.getWarehouse)
                        this.createCSVLocationsLink()
                        this.createCSVLocationTagsLink()
                        await this.createSVGLink(response.data.getWarehouse.upload)
                    }
                }, "csv_dl_error")
            } finally {
                this.csvWorking = false
            }
        },
        createCSVWarehouseLink(warehouse) {
            var csv = "tenantId,id,name,width,height,real_width,real_height,default_shelf_height,default_shelf_width,rssi_threshhold,product_rssi_threshhold,state_change_interval,all_shelves_scan_percentage,remarks,location_tag_filter,item_tag_filter,upload,svg,robot_home_x,robot_home_y,robot_stop_meters,robot_stop_seconds,robot_distance,robot_orientation,shelf_transparency\n"
            csv = csv + this.checkDataNull(warehouse.tenantId) + ","
            csv = csv + this.checkDataNull(warehouse.id) + ","
            csv = csv + this.checkDataNull(warehouse.name) + ","
            csv = csv + this.checkDataNull(warehouse.width) + ","
            csv = csv + this.checkDataNull(warehouse.height) + ","
            csv = csv + this.checkDataNull(warehouse.real_width) + ","
            csv = csv + this.checkDataNull(warehouse.real_height) + ","
            csv = csv + this.checkDataNull(warehouse.default_shelf_height) + ","
            csv = csv + this.checkDataNull(warehouse.default_shelf_width) + ","
            csv = csv + this.checkDataNull(warehouse.rssi_threshhold) + ","
            csv = csv + this.checkDataNull(warehouse.product_rssi_threshhold) + ","
            csv = csv + this.checkDataNull(warehouse.state_change_interval) + ","
            csv = csv + this.checkDataNull(warehouse.all_shelves_scan_percentage) + ","
            csv = csv + this.checkDataNull(warehouse.remarks) + ","
            csv = csv + this.checkDataNull(warehouse.location_tag_filter) + ","
            csv = csv + this.checkDataNull(warehouse.item_tag_filter) + ","
            csv = csv + this.checkDataNull(warehouse.upload) + ","
            csv = csv + this.checkDataNull(warehouse.svg) + ","
            csv = csv + this.checkDataNull(warehouse.robot_home_x) + ","
            csv = csv + this.checkDataNull(warehouse.robot_home_y) + ","
            csv = csv + this.checkDataNull(warehouse.robot_stop_meters) + ","
            csv = csv + this.checkDataNull(warehouse.robot_stop_seconds) + ","
            csv = csv + this.checkDataNull(warehouse.robot_distance) + ","
            csv = csv + this.checkDataNull(warehouse.robot_orientation) + ","
            csv = csv + this.checkDataNull(warehouse.shelf_transparency)

            csv = csv + '\n'
            let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            let blob = new Blob([bom, csv], {
                type: 'text/csv'
            })
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = `Warehouse_` + new Date().getTime() + `.csv`;
            downloadLink.click();

        },
        createCSVLocationsLink() {
            var csv = "id,warehouseId,x,y,width,height,rotation,label,number\n"
            this.listLocations.forEach((item, index) => {
                csv = csv + this.checkDataNull(item.id) + ",",
                    csv = csv + this.checkDataNull(item.warehouseId) + ",",
                    csv = csv + this.checkDataNull(item.x) + ",",
                    csv = csv + this.checkDataNull(item.y) + ",",
                    csv = csv + this.checkDataNull(item.width) + ",",
                    csv = csv + this.checkDataNull(item.height) + ",",
                    csv = csv + this.checkDataNull(item.rotation) + ",",
                    csv = csv + this.checkDataNull(item.label) + ",",
                    csv = csv + this.checkDataNull(item.number)
                csv = csv + '\n'
            })
            let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            let blob = new Blob([bom, csv], {
                type: 'text/csv'
            })
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = `Location_` + new Date().getTime() + `.csv`;
            downloadLink.click();
        },
        createCSVLocationTagsLink() {
            var csv = "id,warehouseId,location_id,epc,x,y\n"
            this.listLocationTags.forEach((item, index) => {
                csv = csv + this.checkDataNull(item.id) + ",",
                    csv = csv + this.checkDataNull(item.warehouseId) + ",",
                    csv = csv + this.checkDataNull(item.location_id) + ",",
                    csv = csv + this.checkDataNull(item.epc) + ",",
                    csv = csv + this.checkDataNull(item.x) + ",",
                    csv = csv + this.checkDataNull(item.y)
                csv = csv + '\n'
            })
            let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            let blob = new Blob([bom, csv], {
                type: 'text/csv'
            })
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = `LocationTag_` + new Date().getTime() + `.csv`;
            downloadLink.click();
        },
        async createSVGLink(upload) {
            if (upload !== undefined && upload !== null) {
                var signedURL = await Storage.get(upload.slice(7), {
                    download: true
                });
                const blob = signedURL.Body;
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `map_` + new Date().getTime() + `.svg`;
                document.body.appendChild(link);
                link.click();
            }
        },
        checkDataNull(data) {
            if (data === undefined) {
                return null
            } else {
                return data
            }
        },
        async handleMapFileUpload(event, warehouseId, index) {
            const files = Array.from(event.target.files);
            if (files.length > 0) {
                this.showOverlay = true
                this.csvUploadMessage = this.$t("csv_upload_loading")

                try {
                    const uploadPromises = files.map(file => {
                        const updatePath = `${this.tenantId}/imports/${warehouseId}/${file.name}`
                        return Storage.put(updatePath, file, {
                            contentType: file.type
                        })
                    });
                    const results = await Promise.all(uploadPromises);
                } catch (error) {
                    console.error('Error uploading files:', error);
                    this.csvUploadMessage = this.$t("csv_upload_error")
                    return
                }
                this.csvUploadMessage = this.$t("csv_upload_success")

                event.target.type = 'text'
                event.target.type = 'file'
            }
        },
        async fetchCustomerMasterData(table) {
            const isCurrent = this.captureRead('search')
            this.currentData = []
            const myInit = {
                limit: this.limit,
                offset: this.offset,
                ...this.setCountRequestParam()
            };

            const response = await AwsApi.graphql({
                query: queries.getCustomerMaster,
                variables: {
                    tableName: table,
                    conditions: JSON.stringify(myInit)
                }
            }, this);
            if (!isCurrent()) return
            if (response === undefined) {
                this.isBusy = false
                return
            }

            const masters = response.data.getCustomerMaster.map(item => JSON.parse(item))
            this.allData = this.allData.concat(masters);
            this.setData();
            if (this.dataChangeFlag) {
                this.dataChangeFlag = false
                this.currentPage = 1
            }
            this.isBusy = false
            this.getCustomItemsCount(table)
        },
        triggerFileInput() {
            document.getElementById('file')?.click()
        },
    },
};
</script>
<style>
.table-wrapper {
  overflow-x: auto;
}

.table-wrapper table {
  white-space: nowrap;
}

.ledger_main_table_th {
    white-space: nowrap;
}

.ledger-sort-header {
    cursor: pointer;
    white-space: nowrap;
}

.sorting {
    cursor: pointer;
}
#ledgerModal___BV_modal_body_ .itemCodeCell {
    display: flex;
}

.upload_csv_label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    margin: 4px 0;
    margin-bottom: 0.22rem;
    margin-top: 0.22rem;
}

.create_label {
    cursor: pointer;
    height: 100%;
    width: 100%;
}
</style>
